
<template>
  <v-container fluid class="white--text pt-0">
      <flow-execution-new></flow-execution-new>
    </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: "FlowExecutionPage",
  components: {
    FlowExecutionNew: () => import("../components/execution_v2/flow/FlowExecutionNew.vue")
  },
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    
  },
}
</script>

<style scoped>

</style>